module.exports = __webpack_public_path__ + "img/jyp_jbt7940_1_1995.asm.86109b7c.jpg";